<template>
  <v-hover v-slot="{ hover }" :key="item.title">
    <v-list-item
      exact
      :to="item.to"
      :disabled="item.disabled"
      @click="$emit('click', item)"
    >
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="menu-item subtitle-2 text-wrap">
          {{ t(item.title) }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action
        v-if="item.useDropdownActions"
        v-show="item.actions && item.actions.length > 0 && hover"
      >
        <v-menu offset-y max-height="calc(100dvh - 40px)" :min-width="170">
          <template #activator="{ on }">
            <slot name="activator" :on="on">
              <v-icon
                icon
                small
                @click.stop.prevent="on.click"
                @mousedown.stop=""
                v-text="'$more_vert'"
              />
            </slot>
          </template>
          <v-list>
            <component
              :is="'DropdownMenuItemDefault'"
              v-for="(itemAction, index) in item.actions"
              :key="index"
              v-testid="`dropdown-menu-item-${index}`"
              :icon="itemAction.icon"
              :title="itemAction.title"
              @click="() => itemAction.action && itemAction.action()"
            />
          </v-list>
        </v-menu>
      </v-list-item-action>
      <template v-else>
        <v-list-item-action
          v-for="itemAction in item.actions"
          :key="itemAction.id"
        >
          <v-icon
            v-show="item.actions && hover"
            class="ma-auto"
            icon
            small
            @click.stop.prevent="$emit('click', itemAction)"
            @mousedown.stop="() => {}"
            >{{ itemAction.icon }}</v-icon
          >
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-hover>
</template>

<script>
import { useI18n } from 'vue-i18n-bridge';
import messages from '@/layouts/menu/menu.i18n.json';

export default {
  name: 'MenuItemDefault',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const { t } = useI18n({
      messages,
      inheritLocale: true,
      useScope: 'local'
    });

    return {
      t
    };
  }
};
</script>
